import React, { useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import api from "../../../apiManager/api";
import { Clipboard } from "lucide-react";
import { formatPayment } from "../../../lib/utils"

export function ExceptionalPayments() {
  const [jobs, setJobs] = useState([]);

  const fetchData = async () => {
    try {
      const res = await api.get("/job/getExceptionalPayments");
      setJobs(res.data.data || []);
    } catch (err) {
      console.error("Error fetching exceptional payments:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangeStatus = async (jobId, currentStatus) => {
    try {
      const targetStatus = currentStatus === "failed" ? "manual" : "failed";

      await api.patch(`/job/changePayoutStatusManually/${jobId}?status=${targetStatus}`);

      fetchData(); // reload table
    } catch (err) {
      console.error("Error updating payout status:", err);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Exceptional Payments</h2>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Amount</TableHead>
            <TableHead>Job Status</TableHead>
            <TableHead>Shoveller Email</TableHead>
            <TableHead>Stripe Account</TableHead>
            <TableHead>Payout Status</TableHead>
            <TableHead>Action</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {jobs.map((job) => {
            const info = job.ShovelerInfo?.[0];
            const sh = info?.ShovelerId;

            return (
              <TableRow key={job._id}>
                <TableCell>
                    Original: {formatPayment(job.paymentInfo?.amount, { is80: false })}<br/>
                    To Give: <span className="text-lg font-bold text-green-700">{formatPayment(job.paymentInfo?.amount,  { is80: true, isVolunteer: job.isRequestedForVolunteer })}</span>
                </TableCell>
                <TableCell>{job.jobStatus}</TableCell>

                <TableCell>
                  {sh?.email}
                  <div className="text-xs text-gray-500">({sh?.userName})</div>
                </TableCell>

                <TableCell>
  <div className="flex gap-6">
    <div>
      {sh?.stripeAccountId}
      <div className="text-xs text-gray-500">
        ({sh?.stripeAccountStatus})
      </div>
    </div>

    <button
      onClick={() => {
        navigator.clipboard.writeText(sh?.stripeAccountId || "");
      }}
      className="p-1 hover:bg-gray-100 rounded transition"
      title="Copy Account ID"
    >
      <Clipboard size={16} />
    </button>
  </div>
</TableCell>

                <TableCell className="capitalize">{info?.PayoutStatus}</TableCell>

                <TableCell>
                  <Button
                    variant="outline"
                    onClick={() => handleChangeStatus(job._id, info?.PayoutStatus)}
                  >
                    {info?.PayoutStatus === "failed"
                      ? "Set payment as done manually"
                      : "Set payment as failed"}
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}